import { api } from "./client";
import { apiRoutes } from "util/apiRoutes";

export interface PromotionCreditBalanceResponse {
  user_id: number;
  balance: number;
  lifetime_earned: number;
  daily_earn_count: number;
  daily_earn_window_started_at?: string | null;
}

const parseNonNegativeInteger = (value: unknown): number => {
  const parsed = Number.parseInt(String(value ?? 0), 10);
  return Number.isFinite(parsed) && parsed >= 0 ? parsed : 0;
};

export const promotionCreditsApi = {
  getBalance: async (): Promise<PromotionCreditBalanceResponse> => {
    const response = await api.get<PromotionCreditBalanceResponse>(apiRoutes.promotionCredits.balance);
    return {
      user_id: Number.parseInt(String(response.data?.user_id ?? 0), 10),
      balance: parseNonNegativeInteger(response.data?.balance),
      lifetime_earned: parseNonNegativeInteger(response.data?.lifetime_earned),
      daily_earn_count: parseNonNegativeInteger(response.data?.daily_earn_count),
      daily_earn_window_started_at: response.data?.daily_earn_window_started_at ?? null,
    };
  },
};
